import { zodResolver } from '@hookform/resolvers/zod';
import { TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import type { TriggerMonthlyClosureReportJobParameters } from '@vy/api-definition';
import { TriggerMonthlyClosureReportJobParametersSchema } from '@vy/api-definition';
import type { Period } from '@vy/types';
import { REPORT_JOB_TYPES } from '@vy/types';
import { vyDate, getMonthPeriod } from '@vy/utils';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import type { TriggerReportJobFormProps } from '../TriggerReportJobDialog';

export const TriggerMonthlyClosureReportJobForm: React.FC<TriggerReportJobFormProps> = ({
  onSubmit,
  dialogActions,
}) => {
  const methods = useForm<TriggerMonthlyClosureReportJobParameters>({
    resolver: zodResolver(TriggerMonthlyClosureReportJobParametersSchema),
    defaultValues: {
      reportJobType: REPORT_JOB_TYPES.MonthlyClosure,
      period: getMonthPeriod(),
    },
  });

  const reportNameRegister = methods.register('reportName');

  const handleSubmit = methods.handleSubmit((data) => {
    const period: Period = {
      endTime: vyDate(data.period.endTime).endOf('day').toDate(),
      startTime: vyDate(data.period.startTime).startOf('day').toDate(),
    };

    onSubmit({ ...data, period });
  });

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit}>
        <div className="mt-3 flex flex-col items-start">
          <TextField {...reportNameRegister} className="w-full" placeholder="Report name" />
          <div className="flex w-full items-center gap-3">
            <Controller
              control={methods.control}
              name="period.startTime"
              render={({ field }) => (
                <DatePicker
                  {...field}
                  views={['month', 'year']}
                  className="my-6 grow"
                  label="Report start date"
                  onChange={(date) => field.onChange(date?.toDate())}
                  value={vyDate(field.value)}
                />
              )}
            />
            -
            <Controller
              control={methods.control}
              name="period.endTime"
              render={({ field }) => (
                <DatePicker
                  {...field}
                  views={['month', 'year']}
                  className="my-6 grow"
                  label="Report end date"
                  onChange={(date) => field.onChange(date?.toDate())}
                  value={vyDate(field.value)}
                />
              )}
            />
          </div>
        </div>
        {dialogActions}
      </form>
    </FormProvider>
  );
};
